module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_amp.cfc0dd27.svg";